const state = {
  headerType: '',
  machineList: [],
  selectedMachine: '',
}

const actions = {
  updateHeaderType({ commit }, payload) {
    commit('updateHeaderType', payload)
  },
  updateMachineList({ commit }, payload) {
    commit('updateMachineList', payload)
  },
  updateSelectedMachine({ commit }, payload) {
    commit('updateSelectedMachine', payload)
  },
}

const getters = {
  getHeaderType: state => {
    return state.headerType
  },
  getMachineList: state => {
    return state.machineList;
  },
  getSelectedMachine: state => {
    return state.selectedMachine;
  },
}

const mutations = {
  updateHeaderType: (state, payload) => {
    state.headerType = payload.headerType
  },
  updateMachineList: (state, payload) => {
    state.machineList = payload.machineList
  },
  updateSelectedMachine: (state, payload) => {
    state.selectedMachine = payload.selectedMachine
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}